import { render, staticRenderFns } from "./modal-phone.vue?vue&type=template&id=3d2c1dbc"
import script from "./modal-phone.vue?vue&type=script&lang=js"
export * from "./modal-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports